import _ from 'lodash';
import { ADMIN_CONTACT_PARTNER, ADMIN_CONTACT_SCHOOL } from '../../constants/admin.contacts.constants';
import { ALL_SELECT_OPTION } from '../../constants/settings.constants';
import { users } from '../bff.api';
import responseValidators from '../response.validators';

const _firstTimeSetupBody = (data) => {
  const result = {
    ..._.pick(data, [
      'email',
      'firstName',
      'lastName',
      'userName',
      'phone',
      'profileId',
      'avatarUrl',
      'type',
      'overwriteRoles'
    ])
  };

  if (result.type === ADMIN_CONTACT_PARTNER) {
    result.organization = data?.organization;
  }

  if (result.type === ADMIN_CONTACT_SCHOOL) {
    const hasAllBranches = data?.branches?.[0] === ALL_SELECT_OPTION.value;
    result.branches = hasAllBranches ? [] : data?.branches;
    const hasAllSchools = data?.schools?.[0] === ALL_SELECT_OPTION.value;
    result.schools = hasAllSchools ? [] : hasAllBranches ? data?.schools : [];
    result.nets = hasAllSchools && hasAllBranches ? data?.nets : [];
  }

  return result;
};
const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const submitFirstTimeSetup = async (data, options = {}) => {
  return users
    .submitFirstTimeSetup(_firstTimeSetupBody(data))
    .then((resp) => {
      responseValidators.submitFirstTimeSetup(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const authService = {
  submitFirstTimeSetup
};

export default authService;
